import './Login.css'
import { useNavigate } from 'react-router-dom'
import {
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from 'firebase/auth'
import { auth, db } from '../../config'
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from 'firebase/firestore'

const Login = () => {
  const nav = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    const email = e.target[0].value
    const password = e.target[1].value

    try {
      await signInWithEmailAndPassword(auth, email, password)
      nav('/')
    } catch (err) {
      alert(err.message)
      console.log('Fail to signup')
    }
  }

  const handleGoogle = async (e) => {
    var provider = new GoogleAuthProvider()

    await signInWithPopup(auth, provider)
      .then(async (result) => {
        var user = result.user

        const q = query(
          collection(db, 'user'),
          where('email', '==', user.email),
        )
        const querySnapshot = await getDocs(q)
        if (querySnapshot.empty) {
          await setDoc(doc(db, 'user', user.uid), {
            uid: user.uid,
            displayName: user.displayName,
            email: user.email,
          })

          await setDoc(doc(db, 'usergroups', user.uid), {})
        }
        nav('/')
      })
      .catch((err) => {
        console.log(err.message)
        alert(err.code)
      })
  }

  return (
    <div className="login">
      <h1>Login</h1>
      <form onSubmit={handleSubmit}>
        <input type={'email'} placeholder={'Email'} />
        <input type={'password'} placeholder={'Password'} />
        <button type={'submit'}>Login</button>
      </form>
      <button className="googleLogin" onClick={handleGoogle}>
        Login with Google
      </button>
    </div>
  )
}

export default Login
